import { EVENT } from "@/constants/event";
import { useEffect, useRef } from "react";

/**
 * Hook: 控制瀑布流重绘
 *
 * 职责：
 * - 监听灵感词模块数量变化
 * - 智能判断是否需要重绘，避免不必要的重绘
 *
 * 重绘策略：
 * 1. 只在模块数量真正增加时触发重绘
 * 2. 在详情页时不触发重绘（用户看不到，延迟到返回发现页时）
 * 3. 从详情页返回发现页时，只有存在"未重绘的新模块"才触发
 *
 * @param displayedModulesSize - 已显示的灵感词模块数量
 * @param isDetailPageOpen - 是否在详情页中
 * @param enabled - 是否启用（默认 true）。当为 false 时，不触发重绘
 */
export function useMasonryRelayout(
  displayedModulesSize: number,
  isDetailPageOpen: boolean,
  enabled = true
) {
  // 记录上次触发重绘时的模块数量
  const lastRelayoutSizeRef = useRef(0);

  useEffect(() => {
    // AB 未开启时跳过所有逻辑
    if (!enabled) return;

    // 核心逻辑：只有当前模块数量大于上次重绘时的数量，才需要重绘
    const hasUnrenderedModules =
      displayedModulesSize > lastRelayoutSizeRef.current;

    // 只在发现页且有未重绘的新模块时触发
    const shouldRelayout = !isDetailPageOpen && hasUnrenderedModules;

    if (shouldRelayout) {
      const timer = setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent(EVENT.MASONRY_RELAYOUT, {
            detail: { isReCompute: false },
          })
        );
        // 更新重绘记录
        lastRelayoutSizeRef.current = displayedModulesSize;
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [displayedModulesSize, isDetailPageOpen, enabled]);
}
